import { render, staticRenderFns } from "./AccountActivation.vue?vue&type=template&id=57c32cc1&scoped=true&"
import script from "./AccountActivation.vue?vue&type=script&lang=js&"
export * from "./AccountActivation.vue?vue&type=script&lang=js&"
import style0 from "./AccountActivation.vue?vue&type=style&index=0&id=57c32cc1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c32cc1",
  null
  
)

export default component.exports